import { FORMS_WORKSITE_JOURNALS_SIGN_AS_SUPERVISOR } from './permissions';

// These permissions will be checked for truthiness even if user is admin or owner of project.
//
// `selectIsRequiredPermission` short-circuits on `isOwner && !isExplicit`, so a
// key listed here is the only kind a project owner or business admin does NOT
// get for free — it has to be granted to them like anyone else.
//
// The valvoja signature is here because the valvoja represents the other side of
// the contract. A contractor's own admin holding the right to sign as the
// supervisor by virtue of being an admin would make that signature meaningless
// on a document whose whole purpose is to record both parties. The vastaava
// työnjohtaja slot is deliberately NOT listed: that one is the contractor's own
// role, so inheriting it with admin rights is correct.
//
// The backend has its own copy of this list — see
// `3-API/src/constants/projectExplicitPermissions.ts` and the owner branch of
// `determinePermissionsOfUserInProject`. Both have to agree, or the option is
// merely hidden rather than refused.
export const PROJECT_EXPLICIT_PERMISSIONS = [
  FORMS_WORKSITE_JOURNALS_SIGN_AS_SUPERVISOR,
];
